module.exports = __webpack_public_path__ + "static/media/11n.27549e7c.png";